import React, { useState, useEffect } from "react";
import axios from "axios";
import Moment from 'react-moment';
import ReactLoading from 'react-loading';
import Modal from 'react-bootstrap/Modal';
import { Container, Row, Col, Form, Button, ProgressBar, ModalFooter } from "react-bootstrap"
import TablePagination from '@mui/material/TablePagination';
import exportValue from "../../apiconfig";
import Left_panel from '../Left_panel'
import Sub_header from '../Sub_header'
import '../../components/loader.css';
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom'

const Payouts_referral = () => {
    const[searchdate,setsearchdate] = React.useState({date:""})
 
    const[modalstate , setmodalstate] = React.useState(false)
    const[isloading , setisloading]= React.useState(false)
    const [otherStates, setOtherState] = useState({ dstatus: "", activePage: 1, rowsPerPage: 100, page: 0, total_count: 0, onload: true });
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState({ isLoading: true, user_list: [] , last_payout:0 , next_payout:0 , total_payout:0 });
    const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
    const [searchTransaction, setsearchTransaction] = React.useState({transaction_id:""});
    const [searchfilters, setsearchFilters] = React.useState({filterStatus:[]})
 
    let admindata = {};
    if (localStorage.getItem('admin_login')) {
      admindata = JSON.parse(localStorage.getItem('admin_login'));
      console.log("admindata------>  -  ",admindata);
      
    }
 const toggleSidebar = () => {
     setIsSidebarOpen(!isSidebarOpen);
     const homeSection = document.querySelector('.home-section');
     if (homeSection) {
         homeSection.classList.toggle('sidebar-closed');
     }
 };
   
    const closeModal = ()=>{
     setmodalstate(false)
    
    }
 
    const getUsersList = (index = 0, onLoad) => {
 
     setIsLoading(true)
     let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/refferal_payout_list`;
     let sendData = { dstatus: otherStates.dstatus, limit: otherStates.rowsPerPage, indexValue: index };
 
     if (searchTransaction.transaction_id!="") {
         sendData.transaction_id = searchTransaction.transaction_id
     }
     if(searchdate.date!=""){
         sendData.date = searchdate.date
     }
     if(searchfilters.filterStatus.length > 0) {
         sendData.status= searchfilters.filterStatus
     }
     console.log("bb", sendData);
     axios.post(full_api, sendData, { headers: exportValue.headers }).then((res) => {
         setIsLoading(false)
         console.log("response ", res);
         console.log("otherStates ", otherStates);
         if (index == 0 && onLoad) {
             setOtherState({ ...otherStates, total_count: res.data.output.length })
 
         }
         setState({ ...state, user_list: res.data.output,  isLoading: false })
 
 
 
     }).catch((e) => {
         setIsLoading(false)
 
     });
 }
 
 const handlePageChange = (event, newPage) => {
     setOtherState({ ...otherStates, page: newPage })
     //console.log("newPage ", newPage);
     getUsersList(newPage);
 }
 const handleChangeRowsPerPage = (event) => {
     console.log("event ", event);
 }
 
 const handlePayout =(e)=>{
     setsearchTransaction({...searchTransaction , transaction_id:e.target.value})
 }
 
 React.useEffect(()=>{
     getUsersList(0, true);
 },[])
 React.useEffect(()=>{
     getUsersList(0, true);
 },[searchdate.date , searchfilters.filterStatus])
    const create_payout = () => {
 
     setisloading(true)
     let full_api = ""
     if(admindata.admin_type==10){
        full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/create_referral_payout_for_am`;
     }
     else if(admindata.admin_type==11){
        full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/create_referral_payout_for_ndr`;
     }
     else{
        full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/create_referral_payout`;
     }
     
     let sendData = {};
 
     console.log("bb", sendData);
     axios.post(full_api, sendData, { headers: exportValue.headers }).then((res) => {
         if(res.data.status==true){
             setisloading(false)
             setmodalstate(false)
            
             Swal.fire(
                 'Good job!',
                 res.data.message,
                 'success'
             )
             getUsersList(0, true);
         }
         else{
             setisloading(false) 
             setmodalstate(false)
           
             Swal.fire(
                 'Oops !',
                 'Something Went Wrong',
                 'unsuccess'
             )
         }
       }).catch((e) => {
         setisloading(false)
         setmodalstate(false)
   
         Swal.fire(
             'Oops !',
             'Something Went Wrong',
             'unsuccess'
         )
      });
 }
 const filter=(e,values)=>{
     const name = e.target.name;
     const value = values;
     const isChecked = e.target.checked;
   
     // Create a new array by spreading the existing filterStatus array
     const updatedFilterStatus = [...searchfilters.filterStatus];
   
     if (isChecked) {
       updatedFilterStatus.push(value);
     } else {
       // Remove the value from the array if unchecked
       const index = updatedFilterStatus.indexOf(value);
       if (index !== -1) {
         updatedFilterStatus.splice(index, 1);
       }
     }
   
     // Update the searchfilters state with the updated filterStatus array
     setsearchFilters((prevFilters) => ({
       ...prevFilters,
       filterStatus: updatedFilterStatus,
     }));
     
    
   }
  return (
    <div>
       <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
       
       <section class="home-section">
               {/* <?php
               include('sub_header.php');
               ?> 
            */}
       <Sub_header/> 
       <Modal show={modalstate} onHide={() =>closeModal()}>
                <Modal.Header closeButton>
                    <Modal.Title>Create a referral payout</Modal.Title>
                </Modal.Header>
                <Modal.Body>
          
      <div class="modal-body">
       
        <small class="text-muted">Payout creation will take some time. Please be patient.</small>
      </div>
<div class="modal-footer">
{isloading? <ReactLoading type={"spin"} color={"#000000"} height={30} width={30} />:
        <button type="button" class="btn btn-primary" onClick={(e)=>create_payout(e)}>Create Payout</button>}
      </div>
           </Modal.Body>
</Modal>
       <section class="mt-3">
        <div class="row mb-3">
            <div class="col-12 col-md-3">
                <h5>Referral Payout Managment</h5>
            </div>
            <div class="col-12 col-md">
                <div class="row">
                    <div class="col-12 col-md">
                    <div class="input-group me-2 me-lg-3 fmxw-400">
                            <select class="form-select">
                              <option>Transcation #</option>
                            </select>
                            <input type="text" class="form-control" placeholder="Search Transcation" onChange={(e)=>handlePayout(e)}/>
                            <span class="input-group-text ">
                                <svg class="icon icon-xs" x-description="Heroicon name: solid/search" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" onClick={(e)=>  getUsersList(0, true)}>
                                    <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd"></path>
                                </svg>
                            </span>
                        </div>
                    </div>
                    <div class="col-12 col-md-3">
                    <input type="date" class="form-control" id="text" placeholder="select date range" onChange={(e)=>setsearchdate({date:e.target.value})}/>
                    </div>
                    <div class="col-12 col-md-2">
                    <div class="btn-group">
                            <button type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown"><i class="fa fa-filter" aria-hidden="true"></i> &nbsp;
                                Filter <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </button>
                            <div class="dropdown-menu">
                                <section class="p-2">
                                <h6>Filter</h6>
                                <hr/>
                                <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="check1" name="option1" value="something" onChange={(e)=>filter(e,0)}/>
                                        <label class="form-check-label">Under Process</label>
                                    </div>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="check1" name="option1" value="something" onChange={(e)=>filter(e,1)}/>
                                        <label class="form-check-label">Completed</label>
                                    </div>
                                </section>
                            
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-2 text-end">
                        <a  class="btn btn-primary"   onClick={(e)=>setmodalstate(true)}>Create Payout</a>
                    </div>
                </div>
            </div>
        </div>



            <div class="card card-body border-0 shadow table-wrapper table-responsive ">
                <table class="table table-hover  shipm_tablew">
                    <thead>
                        <tr>
                            <th class="border-gray-200">Payout #</th>	
                            <th class="border-gray-200">Month</th>
                            <th class="border-gray-200">No of Customer</th>
                            <th class="border-gray-200">Total Amount</th>
                            <th class="border-gray-200">Status</th>
                            <th class="border-gray-200">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                      {state.user_list.map((item)=>(
                        <tr>
                            <td>
                                <h5><a href={`/payouts_refer_trans_list/${item.payout_referral_id}`} class="text-info fw-700 fs-6">{item.payout_referral_id}</a></h5>
                            </td>                        
                            <td>
                            {item.create_month}
                            </td>
                            <td class="">
                                <strong>{item.total_customer}</strong>
                            </td>
                            <td class="fw-700 text-danger">
                            ₹{item.total_amount}
                            </td>
                            <td>
                           {item.status==0?     <span class="status pay_pending"> <i class="fa fa-clock-o" aria-hidden="true"></i> Under Process</span>:<span class="status pay_success"> <i class="fa fa-clock-o" aria-hidden="true"></i> Completed</span>}
                            </td>
                            <td>
                                <a href={`/payouts_refer_trans_list/${item.payout_referral_id}`}  class="btn btn-outline-info  btn-sm"><i class="material-icons-outlined fs-20" data-bs-toggle="tooltip" title="View Deatils">receipt</i></a>
                                {/* <a href="payouts_refer_trans_list.php" class="btn btn-outline-primary  btn-sm"><i class="material-icons-outlined fs-20" data-bs-toggle="tooltip" title="Update Status">refresh</i></a> */}
                            </td>
                        </tr>
                        ))}
                    </tbody>
                </table>
               
            </div> 
                    

    </section>
       </section>
    <TablePagination
                            component="div"
                            rowsPerPageOptions={[100,150,200,250]}
                            count={otherStates.total_count}
                            page={otherStates.page}
                            onPageChange={handlePageChange}
                            rowsPerPage={otherStates.rowsPerPage}
                            onRowsPerPageChange={handleChangeRowsPerPage}

                        />
   
    </div>
  )
}

export default Payouts_referral
